import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Holidays from "./pages/Holidays";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/toaster";
import FloatingActions from "./components/FloatingActions";

function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-800">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/holidays" element={<Holidays />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <FloatingActions />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
